// s155 (D-155.4, CONSISTENCY-PASS-1): the ONE standard "saved elsewhere" notice.
//
// A muted, persistent, SOURCE-SIDE line shown wherever a value the planner enters in one
// section also flows to another — so the copy is never SILENT (flows that used to write
// with no feedback) and never announced two DIFFERENT ways (a toast here, a bespoke
// pointer there). Retires the ad-hoc `Copied to …` toast and the one-off Rent pointer.
//
// Style matches the existing guidance-line family (DM Sans 13px, sage #4F6B51) — the same
// treatment the old Rent pointer used, so it reads as a quiet confirmation, not a warning.

import { FONT, SAGE } from "@shared/brand";
interface SavedElsewhereNoticeProps {
  /** Human destination label (resolved from the flow config, e.g. the target section's
   *  display name: "Properties", "Housing", "Family & Pets"). Used with the standard
   *  sentence. Ignored when `message` is supplied. */
  destination?: string;
  /** A full custom sentence for flows whose destination isn't a plain section label
   *  (e.g. the Gov-ID name sync: "Your name is saved on your Government ID records.").
   *  Overrides the standard destination sentence. */
  message?: string;
  testId?: string;
}

export function SavedElsewhereNotice({ destination, message, testId }: SavedElsewhereNoticeProps) {
  if (!message && !destination) return null; // nothing resolved yet → render nothing
  return (
    <p
      style={{ fontFamily: FONT.sans, fontSize: 13, color: SAGE[600], lineHeight: 1.4, marginTop: 6 }}
      data-testid={testId ?? "saved-elsewhere-notice"}
    >
      {message ?? <>Also saved in {destination}. You can add more detail there.</>}
    </p>
  );
}
